import BaseError from "./BaseError";

export default class ExcelApiError extends BaseError {
  constructor(message: string, statusCode?: number | string, info?: any, cause?: OfficeExtension.Error) {
    super({
      statusCode: statusCode || 590, // custom Excel API error code
      message,
      info: info || null,
      cause,
    });
    this.name = "ExcelApiError";
  }
}
